<template>
  <div class="feature">
    <div class="groupItem noteWindow">
		<h4 class="noteTitle">EVENT NOTIFICATION WINDOW</h4>
		<notifications group="events" position="top center"/>
	</div>
	<h4 class="title"><p>{{feature.title}}</p></h4>
	<div class="blurbText">{{feature.blurb}}</div>
  </div>
</template>


<script>
export default {
    name: 'FeatureItem',
    props: ['feature'],
    mounted: function () {
        this.next = 0;
        this.$nextTick(function() {
        this.updateNoteFunc = window.setInterval(() => {this.nextNote()}, 750);
        });
    },
    beforeDestroy: function() {
        this.$notify({
            group: 'events',
            clean: true
        });
        window.clearInterval(this.updateNoteFunc);
    },
    methods: {
            nextNote() {
	
	  switch(this.next)
	  {
		  case 0:
		  {
			  this.$notify({
				group: 'events',
				title: 'MEETING: Reminder',
				text: 'Next Meeting is at 2:15pm at HALL B',
				classes: ['notifications'],
				duration: 9990000,
				});
			break;
		  }
		  case 1:
		  {
			  this.$notify({
				group: 'events',
				title: 'FROM: Bob',
				text: 'Meet me for lunch by the loading docks',
				classes: ['notifications'],
				duration: 999000,
				});
			break;
		  }
		  case 2:
		  {
			  this.$notify({
				group: 'events',
				title: 'REWARD: Gift',
				text: 'Recieve your free gift for completing training 1033',
				classes: ['notifications'],
				duration: 10000,
				});
			break;
		  }
		  default:
		  {
			  break;
		  }
	  }
	  
	  this.next++;
    }
    }
}
</script>
<style lang="scss" scoped>
.feature {
	border: 1px solid $darkblue;
	margin: 1%;
	padding-bottom: 1%;
}
.featureImg {
	width: 100%;
	height: 150px;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	position: relative;
}
.title {
	//background-color: $darkblue;
	color: white;
    color: black;
    display: flex;
	justify-content: center;
    
    p {
        margin: 0;
		padding-bottom: 0.8rem;
		border-bottom: $blue 2px solid;
	}
}
.blurbText {
	padding-bottom: 1rem;
	padding-right: 1rem;
	padding-left: 1rem;
}
.groupItem {
	width: 50%;
	// margin: 1%;
}
.noteWindow {
	border: solid 1px $darkblue;
    background-color: $darkblue;
    width: 100%;
    height: 260px;
}
.notifications {
	display: block;
	position: relative;
}
.noteTitle {
	color: white;
}
</style>
